import React from "react";
import {getRecordingType, onShareRecording} from "../../../../recording/utils";
import PriorityLevel from "../../../../recording/information/PriorityLevels";
import Speed from "../../../../recording/information/Speed";
import Size from "../../../../recording/information/Size";
import Runtime from "../../../../recording/information/Runtime";
import PrivacyLevels from "../../../../recording/information/PrivacyLevels";
import {getFormattedDateForTitle} from "../../../../../utils/date";

/**
 * Video player for showing historical playback recordings
 * @param title of the video.
 * @param thumbnailURL of the placeholder to be displayed before playback.
 * @param URL of the video/ video stream to be played.
 * @param backupURL of the video/ video stream to be played in case {@param URL} is invalid.
 * @returns a playback video component that can load links and play them.
 * @Note that you are required to import the delight-vr script in index.html or anywhere convenient for the tags below to work.
 */
const PlaybackVideoPlayer = (props) => {
    /**
     * Initiates the pop up player for the playback viewer. The player would be full screen.
     * For more information, please visit https://delight-vr.com/documentation/dl8-video/
     */
    return (
        <div>
            <dl8-video
                style={{maxHeight: 'calc(100vh - 250px)', minHeight: 150}}
                poster={props.thumbnailURL}
                format="MONO_360"
                seekable
            >
                {
                    // Note: Only some video elements have a URL so
                    // we add them only when present to prevent failures.
                }
                {
                    props.URL &&
                    <source src={props.URL} type={getRecordingType(props.URL)} />
                }
                {
                    props.backupURL &&
                    <source src={props.backupURL} type={getRecordingType(props.backupURL)} />
                }
            </dl8-video>
            <div className="recordings-modal-content">
                <h5>{props.title}</h5>
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 text-muted small">{getFormattedDateForTitle(props.date)}</div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 text-muted small">{props.carName}</div>
                </div>
                <p>{props.description}</p>
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><PriorityLevel rawPriority={props.rawPriority}/></div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><PrivacyLevels runtime={props.privacy}/></div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><Runtime runtime={props.runtime}/></div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><Size size={props.size}/></div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><Speed speed={props.speed}/></div>
                </div>
                <div className="text-center">
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={onShareRecording(props.privacy, props.recordingUrl, props.unitID, props.recordingID)}
                    >
                        <i className="fas fa-share"/> Share
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PlaybackVideoPlayer;



// WEBPACK FOOTER //
// ./src/components/unit/recordings/recordingcard/playback/PlaybackVideoPlayer.jsx